import type { RebalancePreviewResponse } from "../../lib/api";

export interface TradeRow {
	assetId: string;
	deltaUsdcRaw: string;
	side: "buy" | "sell";
}

export function buildTradeRows(data: RebalancePreviewResponse): TradeRow[] {
	const rows: TradeRow[] = [];
	for (const [assetId, raw] of Object.entries(
		data.deltaValues.assetDeltaValuesRaw,
	)) {
		const bi = BigInt(raw);
		if (bi === 0n) continue;
		rows.push({ assetId, deltaUsdcRaw: raw, side: bi > 0n ? "buy" : "sell" });
	}
	rows.sort((a, b) => {
		const av = BigInt(a.deltaUsdcRaw);
		const bv = BigInt(b.deltaUsdcRaw);
		const aa = av < 0n ? -av : av;
		const ab = bv < 0n ? -bv : bv;
		return aa > ab ? -1 : aa < ab ? 1 : 0;
	});
	return rows;
}

export interface WeightRow {
	assetId: string;
	before: string;
	after: string;
	delta: number;
}

export function buildWeightRows(data: RebalancePreviewResponse): WeightRow[] {
	const ids = new Set<string>([
		...Object.keys(data.stateOld.assetWeights),
		...Object.keys(data.stateNew.assetWeights),
	]);
	const rows: WeightRow[] = [];
	for (const id of ids) {
		const before = data.stateOld.assetWeights[id] ?? "0";
		const after = data.stateNew.assetWeights[id] ?? "0";
		rows.push({
			assetId: id,
			before,
			after,
			delta: Number(after) - Number(before),
		});
	}
	rows.push({
		assetId: "cash",
		before: data.stateOld.cashWeight,
		after: data.stateNew.cashWeight,
		delta: Number(data.stateNew.cashWeight) - Number(data.stateOld.cashWeight),
	});
	rows.sort((a, b) => Math.abs(b.delta) - Math.abs(a.delta));
	return rows;
}

export function apyByAssetMap(
	data: RebalancePreviewResponse,
): Record<string, string> {
	const map: Record<string, string> = {};
	for (const q of data.input.quotes) map[q.assetId] = q.expectedNetApy;
	return map;
}
